import React from 'react';
import { Helmet } from 'react-helmet';
import { logo_home } from '../../../Data/Images/Home';
import appStoreBadge from '../../../assets/images/landing/app-store-badge-fr.svg';
import googlePlayBadge from '../../../assets/images/landing/google-play-badge-fr.png';

// Always French — this page is only reached via the Classmed pharmacy QR code, not the ?lang= layer.
const COPY = {
  metaTitle: "Télécharger l'application Classmed | riise.",
  metaDesc:  "Télécharge l'application Classmed pour voir ton résultat et gérer ta pharmacie.",
  heading:   "Télécharge l'application Classmed",
  subline:   "Choisis ton store pour installer l'application.",
  appleAlt:  "Télécharger dans l'App Store",
  googleAlt: "Disponible sur Google Play",
};

const SERIF = { fontFamily: "'DM Serif Display', serif" };
const SANS  = { fontFamily: "'Plus Jakarta Sans', sans-serif" };

const APPLE_URL  = 'https://apps.apple.com/fr/app/class-med/id6502191184';
const GOOGLE_URL = 'https://play.google.com/store/apps/details?id=com.servicesnomades.classmed';

// Official store badges, shipped unmodified as Apple's and Google's brand guidelines require.
// Google's asset bakes in its own clear space — 192px of artwork inside a 250px-tall file — so it
// renders 250/192 taller than Apple's to land both badges on the same visible height. Apple's badge
// carries no built-in padding, so its link box is padded to match Google's overall height.
const BADGE_HEIGHT = 48;
const GOOGLE_BADGE_HEIGHT = Math.round((BADGE_HEIGHT * 250) / 192);

const StoreBadge = ({ href, src, alt, height }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: GOOGLE_BADGE_HEIGHT, textDecoration: 'none',
    }}
  >
    <img src={src} alt={alt} style={{ height, width: 'auto', display: 'block' }} />
  </a>
);

const ClassmedAppDownload = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#F9F9F9', display: 'flex',
      flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '48px 24px' }}>
      <Helmet>
        <html lang="fr" />
        <title>{COPY.metaTitle}</title>
        <meta name="description" content={COPY.metaDesc} />
        <meta name="robots" content="noindex" />
      </Helmet>

      <div style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <img src={logo_home} alt="riise." style={{ height: 32, margin: '0 auto 40px' }} />

        <h1 style={{ ...SERIF, fontSize: 32, color: '#103642', margin: '0 0 16px' }}>
          {COPY.heading}
        </h1>
        <p style={{ ...SANS, fontSize: 16, color: 'rgba(16,54,66,0.75)', margin: '0 0 40px', lineHeight: 1.5 }}>
          {COPY.subline}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <StoreBadge
            href={APPLE_URL}
            src={appStoreBadge}
            alt={COPY.appleAlt}
            height={BADGE_HEIGHT}
          />
          <StoreBadge
            href={GOOGLE_URL}
            src={googlePlayBadge}
            alt={COPY.googleAlt}
            height={GOOGLE_BADGE_HEIGHT}
          />
        </div>
      </div>
    </div>
  );
};

export default ClassmedAppDownload;
